import { ChartValueFormatting } from "../enums";

export interface IReportChartDataSet {
    label: string;
    data: number[];
    chartValueFormatting: ChartValueFormatting;
    showDataLabels: boolean;
}

export class ReportChartDataSet implements IReportChartDataSet {
    label: string;
    data: number[];
    chartValueFormatting: ChartValueFormatting;
    showDataLabels: boolean;

    constructor();
    constructor(obj: IReportChartDataSet);
    constructor(obj?: any) {
        this.label = obj && obj.label || "";
        this.data = obj && obj.data || [];
        this.chartValueFormatting = obj && obj.chartValueFormatting || ChartValueFormatting.None;
        this.showDataLabels = obj && obj.showDataLabels || false;
    }

    static createReportChartDataSet(label: string, data: number[], chartValueFormatting: ChartValueFormatting = ChartValueFormatting.None, showDataLabels: boolean): ReportChartDataSet {
        const result = new ReportChartDataSet();
        result.label = label;
        result.data = data;
        result.chartValueFormatting = chartValueFormatting;
        result.showDataLabels = showDataLabels;
        return result;
    }
}